import { initialize, LDClient } from "launchdarkly-js-client-sdk";
import { LDContext } from "launchdarkly-js-sdk-common";

const launchDarklyId: string = import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID;

import { TAuthUser } from "../api/user/types";

export type TFeatureFlag =
  | "app.insights"
  | "ui.user.pools.beta"
  | "user.app.ask.momentum"
  | "generic-ui-flag"
  | "app.scheduled-notifications.run-every-minute"
  | "ai.summary.action.buttons"
  | "dataInsight.reasonField"
  | "app.migration.from.using.jsonEditor.in.wizard"
  | "user.flow.filter.logic"
  | "ui.spotless.config"
  | "ai.select.case.object";

export async function getAllFlags(authUser: TAuthUser): Promise<Record<TFeatureFlag, boolean>> {
  const ldUser: LDContext = {
    custom: { organizationId: authUser.organizationId },
    // Get feature-flags for impersonated user (profile.email), not authenticated user (authUser.email)
    email: authUser.email,
    key: String(authUser.userId),
  };

  const ldClient: LDClient = initialize(launchDarklyId, ldUser);
  await ldClient.waitForInitialization(4);
  //there's a few deprecated flags that are not used anymore so we need to remove them the TFeatureFlag is what we are using in the app
  const allFlags = ldClient.allFlags() as Record<TFeatureFlag, boolean>;

  return allFlags;
}
